import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

const root = ReactDOM.createRoot(document.getElementById("root"));
// Service worker: production builds (or opt-in for testing via localStorage crewz_sw_dev=1)
if ('serviceWorker' in navigator) {
  let devOptIn = false;
  try { devOptIn = localStorage.getItem('crewz_sw_dev') === '1'; } catch { /* noop */ }
  if (process.env.NODE_ENV === 'production' || devOptIn) {
    window.addEventListener('load', () => {
      navigator.serviceWorker.register('/sw.js').catch((e) => console.warn('SW registration failed', e));
    });
  }
}

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
